import React, { useEffect, useState } from "react";

import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import HeaderComponent from './header_component'
import TopBarComponent from './../protected/component/topbar_component'
import AuthenticationService from '../../service/authentication_service';

// import './../../asset/css/icofont.min.css';
// import './../../asset/css/animate.min.css';
// import './../../asset/css/owl.carousel.min.css';
// import './../../asset/css/aos.css';
// import './../../asset/css/bootstrap.min.css';
//import './../../asset/css/style.css';
// import './../../asset/css/responsive.css';


const LandingPage = () => {

    const [counter, setCounter] = useState(0);

    useEffect(() => {

        //eslint-disable-next-line
    }, []);



    






    return (
        <div className="page_wrapper" style={{ fontSize: '20px'}}>
        {/* Preloader */}
        <div id="preloader">
          <div className="circle-border">
            <div className="circle-core" />
          </div>
        </div>
        {/* Top Banner Start*/}
        <div className="top_home_wraper white_option">
          {/* Header Start */}
          <header className="fixed">
            {/* container start */}
            <div className="container">
              {/* navigation bar */}
              <nav className="navbarr navbar-expand-lg">
                <a className="navbar-brand" href="/">
                  <img src="/images/logo.png" alt="image" />
                </a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon">
                    {/* <i class="icofont-navigation-menu ico_menu"></i> */}
                    <div className="toggle-wrap">
                      <span className="toggle-bar" />
                    </div>
                  </span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul className="navbar-nav ml-auto">
                    <li className="nav-item active">
                      <a className="nav-link" href="/">Home</a>
                    </li>

                    {!AuthenticationService.getToken() && <li className="nav-item">
                    <Link className="nav-link" to="/signin">Login</Link>
                      </li> }
                    {AuthenticationService.getToken() && <li className="nav-item">
                    <a className="nav-link" href="/dashboard">Dashboard</a>
                      </li> }
                    {AuthenticationService.getToken() && <li className="nav-item">
                    <a className="nav-link" href="/giveaway/detail/ALL">Giveaways</a>
                      </li> }


                    {/* <li class="nav-item">
                  <a class="nav-link" href="about-us.html">About us</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="service-list-2.html">Solutions</a>
                </li> */}
                  </ul>
                </div>
              </nav>
              {/* navigation end */}
            </div>
            {/* container end */}
          </header>
          {/* Banner-Section-Start */}
          <section className="banner_section">
            {/* animated dots */}
            <div className="dotes_anim_bloack">
              <div className="dots dotes_1" />
              <div className="dots dotes_2" />
              <div className="dots dotes_3" />
              <div className="dots dotes_4" />
              <div className="dots dotes_5" />
              <div className="dots dotes_6" />
              <div className="dots dotes_7" />
              <div className="dots dotes_8" />
            </div>
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-md-12">
                  <div className="banner_text">
                    <div className="ban_inner_text" data-aos="fade-up" data-aos-duration={1500}>
                      <span><i className="icofont-rocket-alt-2" /> Building efficient systems for different sectors</span>
                      <h1 style={{fontSize: '70px', marginBottom: '0'}}>Oneorbit</h1>
                      <sub style={{color: 'black', float: 'right', left: (window.innerWidth < 720 ? '0' :'-250px')}}>technologies</sub>
                      <h2 style={{marginTop: '18px'}}>Unifying systems and industries</h2>
                      <p>Leading platform that is bringing everything together</p>
                      <p><a href="/signin" className="btn text_btn">Get Started <i className="icofont-arrow-right" /></a></p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="banner_image" data-aos="fade-up" data-aos-duration={1500}>
                    <img src="/images/new/hero_image.png" alt="image" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        {/* Top Banner End*/}
        {/* Unique features Start */}
        <section className="row_am unique_section">
          <div className="container">
            <div className="section_title" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={100}>
              {/* h2 */}
              <h2>Products </h2>
              {/* p */}
              <p>Our awesome products that help manage information from different sectors include</p>
            </div>
            <div className="features_inner" data-aos="fade-up" data-aos-duration={2000} data-aos-delay={100}>
              {/* card */}
              {/* <div className="feature_card">
                <div className="icons">
                  <img src="/images/new/features_icon_01.svg" alt="image" />
                  <div className="dot_block">
                    <span className="dot_anim" />
                    <span className="dot_anim" />
                    <span className="dot_anim" />
                  </div>
                </div>
                <div className="inner_text">
                  <h3>Tradexsafely</h3>
                  <p>Leading escrow service provider that protects buyers and sellers from online fraud.
                  </p>
                  <a href="https://tradexsafely.com" target="_blank" className="btn text_btn">DISCOVER MORE <i className="icofont-arrow-right" /></a>
                </div>
              </div> */}
              {/* card */}
              <div className="feature_card">
                <div className="icons">
                  <img src="/images/new/features_icon_02.svg" alt="image" />
                  <div className="dot_block">
                    <span className="dot_anim" />
                    <span className="dot_anim" />
                    <span className="dot_anim" />
                  </div>
                </div>
                <div className="inner_text">
                  <h3>Dogiveaway</h3>
                  <p>Charity management system used by NGO's and individuals for disbursement of cash and airtime to beneficiaries.
                  </p>
                  <a href="https://dogiveaway.com" target="_blank" className="btn text_btn">DISCOVER MORE <i className="icofont-arrow-right" /></a>
                </div>
              </div>
              {/* card */}
              <div className="feature_card">
                <div className="icons">
                  <img src="/images/new/features_icon_03.svg" alt="image" />
                  <div className="dot_block">
                    <span className="dot_anim" />
                    <span className="dot_anim" />
                    <span className="dot_anim" />
                  </div>
                </div>
                <div className="inner_text">
                  <h3>Mercury</h3>
                  <p>School management system used by primary and secondary schools for managing day to day operation in schools.
                  </p>
                  <a href="https://school.unifiedorbit.com" target="_blank" className="btn text_btn">DISCOVER MORE <i className="icofont-arrow-right" /></a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Unique features End */}
        {/* Analyze Section Strat */}
        {/* <section className="row_am analyze_section">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="analyze_text" data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100}>
                  <span className="icon"><img src="/images/new/securely.svg" alt="image" /></span>
                  <div className="section_title">
                    <h2>Protect your online transactions</h2>
                    <p>You need not worry anymore about fraudulent buyers or sellers online. Gone are the days when you get
                      robbed of your money from unknow persons online. You can secure all of your online transactions using our tradexsafely
                      solution. Buyer is sure of delivery of product or service, and seller is sure of payment upon delivery.
                      It's a WIN-WIN solution.
                    </p>
                  </div>
                  <ul>
                    <li data-aos="fade-up" data-aos-duration={2000}>
                      <h3>Carefully designed</h3>
                      <p>Tradexsafely is carefully designed to meet all security standards needed to secure all of our users and transactions.</p>
                    </li>
                    <li data-aos="fade-up" data-aos-duration={2000}>
                      <h3>Seamless UI</h3>
                      <p>Navigating and understanding the steps needed to complete a secured transaction is easy.</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <div className="analyze_image" data-aos="fade-in" data-aos-duration={1000}>
                  <img data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100} className="moving_animation" src="/images/new/analyze-data-01-txs.png" alt="image" />
                  <img data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100} className="moving_animation" src="/images/new/analyze-data-02-txs.png" alt="image" />
                  <img data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100} className src="/images/new/analyze-data-txs.png" alt="image" />
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* Analyze Section End */}
        {/* Collaborate Section Strat */}
        <section className="row_am collaborate_section">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="collaborate_image" data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100}>
                  <div className="img_block" data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100}>
                    <img className="icon_img moving_animation" src="/images/new/Collaborate-icon_1.png" alt="image" />
                    <img src="/images/new/Collaborate-01-dogiveaway.png" alt="image" />
                  </div>
                  <div className="img_block" data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100}>
                    <img src="/images/new/Collaborate-01-dogiveaway.png" alt="image" />
                    <img className="icon_img moving_animation" src="/images/new/Collaborate-icon_2.png" alt="image" />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="collaborate_text" data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100}>
                  <span className="icon"><img src="/images/new/Analyze_Icon.svg" alt="image" /></span>
                  <div className="section_title">
                    <h2>Do giveaway conveniently</h2>
                    <p>
                      Instead of always asking your beneficiaries to share their account details or phone number so that you can transfer
                      money to them or send them airtime, why not send a link to them carry the amount you want to bless them with and they 
                      get to chose which network or bank account they want the blessing to go to.
                      <br />
                      This is what dogiveaway offers both the giver and the receiver. Super convinience for all.
                    </p>
                  </div>
                  <ul>
                    <li data-aos="fade-up" data-aos-duration={2000}>
                      <h3>Cash or Airtime Reward</h3>
                      <p>You get to decide if its cash or airtime you wish to giveaway. Also you can have fun while at it by
                        either playing a game of fastest finger claims the giveaway or everyone roll a dice and the highest number wins.
                      </p>
                    </li>
                    <li data-aos="fade-up" data-aos-duration={2000}>
                      <h3>Insight</h3>
                      <p>You now have insight into how much of your giveaways have been redeemed, and who are those winning the 
                        game.</p>
                    </li>
                  </ul>
                  <a href="https://dogiveaway.com" target="_blank" data-aos="fade-up" data-aos-duration={2000} className="btn btn_main">READ MORE <i className="icofont-arrow-right" /></a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Analyze Section End */}
        {/* Communication Section Strat */}
        <section className="row_am communication_section">
          <div className="communication_inner">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="communication_text" data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100}>
                    <span className="icon"><img src="/images/new/comunication.svg" alt="image" /></span>
                    <div className="section_title">
                      <h2>Mercury</h2>
                      <p style={{fontFamily: 'Georgia', fontSize: '20px'}}>Mercury offers the best platform for 
                        <strong style={{color: 'var(--main_purple)'}}>collaboration</strong> between parents, students, teachers and school 
                        management towards 
                        the <strong style={{color: 'var(--main_purple)'}}>growth </strong>  
                        and <strong style={{color: 'var(--main_purple)'}}> development</strong> of
                        a <strong style={{color: 'var(--main_purple)'}}>child</strong>. 
                        Get involved in the day to day growth of a child. 
                        Get daily, weekly, monthly 
                        and yearly report on academic and social performance. Save cost, time and make smart decisions that are data driven.
                      </p>
                    </div>
                    <ul>
                      <li data-aos="fade-up" data-aos-duration={2000}>
                        <h3>Collaboration made easy</h3>
                        <p>
                          From the moment a child steps into the school, all his/her activities are reported and made available to the parents 
                          and the school management. 
                        </p>
                      </li>
                      <li data-aos="fade-up" data-aos-duration={2000}>
                        <h3>Transcript and Transfers</h3>
                        <p>When people transfer to other schools, they get to leave behind their academic history behind. This is no longer 
                          the case with mercury. You can have a detailed Transcript generated for your, or you can make your data from your 
                          previous schools available to your new school via our <strong>Share and Sync</strong> feature.
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="communication_image" data-aos="fade-in" data-aos-duration={1000}>
                    <img data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100} className="moving_animation" src="/images/new/cominication-data-03.png" alt="image" />
                    <img data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100} className="moving_animation" src="/images/new/cominication-data-02.png" alt="image" />
                    <img data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100} className src="/images/new/cominication-data-01-mercury.png" alt="image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Communication Section End */}
        <section className="row_am collaborate_section">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="collaborate_image" data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100}>
                  <div className="img_block" data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100}>
                    <img className="icon_img moving_animation" src="/images/new/Collaborate-icon_1_agrictech.png" alt="image" />
                    <img src="/images/new/Collaborate-01_agrictech.png" alt="image" />
                  </div>
                  <div className="img_block" data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100}>
                    <img src="/images/new/Collaborate-02_agrictech.png" alt="image" />
                    <img className="icon_img moving_animation" src="/images/new/Collaborate-icon_2_agrictech.png" alt="image" />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="collaborate_text" data-aos="fade-in" data-aos-duration={2000} data-aos-delay={100}>
                  <span className="icon"><img src="/images/new/Analyze_Icon.svg" alt="image" /></span>
                  <div className="section_title">
                    <h2>Agrictech</h2>
                    <p style={{fontFamily: 'Georgia', fontSize: '20px'}}>
                      Our agrictech is a digital platform that connects farmers, growers, and buyers in the agriculture industry. 
                      The software allows farmers and growers to create listings for their produce and sell directly to buyers. 
                      The platform provides a centralized hub for all transactions, eliminating the need for intermediaries and 
                      reducing costs for both farmers and buyers. You also can enumerate farmers and also manage disbursement of subsidised
                      agricultural inputs to farmers.
                      <br />
                      We are covering the entire value chain of the agricultural ecosystem.
                    </p>
                  </div>
                  <ul>
                    <li data-aos="fade-up" data-aos-duration={2000}>
                      <h3>Farmers Enumeration and Subsidy</h3>
                      <p>With agrictech you can register farmers and their farm locations, and also manage the distribution of subsidised 
                        agricultural inputs like seeds, fertilizers, chemicals, etc.
                      </p>
                    </li>
                    <li data-aos="fade-up" data-aos-duration={2000}>
                      <h3>Marketplace</h3>
                      <p>Our agrictech marketplace provides a convenient and efficient platform for farmers, growers, 
                        and buyers to connect, transact, and build relationships in the agriculture industry.
                      </p>
                    </li>
                  </ul>
                  <a href="https://agrictech.unifiedorbit.com" target="_blank" data-aos="fade-up" data-aos-duration={2000} className="btn btn_main">READ MORE <i className="icofont-arrow-right" /></a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Powerful solution for your business Section Start */}
        {/* <section class="powerful_solution" data-aos="fade-in" data-aos-duration="1000">
      
      <div class="dotes_anim_bloack">
        <div class="dots dotes_1"></div>
        <div class="dots dotes_2"></div>
        <div class="dots dotes_3"></div>
        <div class="dots dotes_4"></div>
        <div class="dots dotes_5"></div>
        <div class="dots dotes_6"></div>
        <div class="dots dotes_7"></div>
        <div class="dots dotes_8"></div>
      </div>

      <div class="bg_pattern">
        <img src="/images/new/business_vectore.png" alt="image">
      </div>
      <div class="container">
        <div class="counters_block" data-aos="fade-up" data-aos-duration="1000">
          <ul class="app_statstic" id="counter" data-aos="fade-in" data-aos-duration="1500">
            <li>
              <div class="text">
                <p><span class="counter-value" data-count="450">0</span><span>+</span></p>
                <p>Million of client logins monthly</p>
              </div>
            </li>
            <li>
              <div class="text">
                <p><span class="counter-value" data-count="120">0 </span><span>+</span></p>
                <p>Languages and countries</p>
              </div>
            </li>
            <li>
              <div class="text">
                <p><span class="counter-value" data-count="135">1500</span><span>+</span></p>
                <p>Percent yearly turnover increase</p>
              </div>
            </li>
            <li>
              <div class="text">
                <p><span class="counter-value" data-count="324">0</span><span>+</span></p>
                <p>Million active accounts</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="images_gallery_block row">
          <div class="gl_block col-md-3 col-sm-6" data-aos="fade-up" data-aos-duration="1000">
            <div class="img"><img src="/images/new/Powerful-solution-01.png" alt="image"></div>
            <div class="img"><img src="/images/new/Powerful-solution-02.png" alt="image"></div>
          </div>
          <div class="gl_block col-md-3 col-sm-6" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
            <div class="img"><img src="/images/new/Powerful-solution-03.png" alt="image"></div>
            <div class="img"><img src="/images/new/Powerful-solution-04.png" alt="image"></div>
            <div class="img"><img src="/images/new/Powerful-solution-05.png" alt="image"></div>
          </div>
          <div class="gl_block col-md-3 col-sm-6" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="150">
            <div class="img"><img src="/images/new/Powerful-solution-06.png" alt="image"></div>
            <div class="img"><img src="/images/new/Powerful-solution-07.png" alt="image"></div>
          </div>
          <div class="gl_block col-md-3 col-sm-6" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
            <div class="img"><img src="/images/new/Powerful-solution-08.png" alt="image"></div>
            <div class="img"><img src="/images/new/Powerful-solution-09.png" alt="image"></div>
          </div>
        </div>
      </div>
    </section> */}
        {/* Powerful solution for your business Section End */}
        {/* What Our Coustomer Section Start*/}
        {/* <section class="what_coustomer_says">
      <div class="container">
        <div class="section_title" data-aos="fade-up" data-aos-duration="1500">
          <h2>What our customer says</h2>
          <p>Lorem Ipsum is simply dummy text of the printing and typese tting indus <br> orem Ipsum has beenthe
            standard dummy text ever since.</p>
        </div>
        <div id="coustomer_slider_white" class="owl-carousel owl-theme" data-aos="fade-in" data-aos-duration="1500">
          <div class="item">
            <div class="coustomer_slide_box">
              <div class="rating">
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
              </div>
              <p>Lorem Ipsum is simply dummy text of the print ing and typese tting us orem Ipsum has been.</p>
              <div class="avtar_profil">
                <div class="avatr">
                  <img src="/images/new/testi_01.png" alt="image">
                </div>
                <div class="text">
                  <h3>Shayna john</h3>
                  <span>Careative inc.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="coustomer_slide_box">
              <div class="rating">
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
              </div>
              <p>Simply dummy text of the print ing and typese tting us orem Ipsum has been lorem Ipsum.</p>
              <div class="avtar_profil">
                <div class="avatr">
                  <img src="/images/new/testi_02.png" alt="image">
                </div>
                <div class="text">
                  <h3>Mark </h3>
                  <span>Careative inc.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="coustomer_slide_box">
              <div class="rating">
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
              </div>
              <p>Lorem Ipsum is simply dummy text of the print ing and typese tting us orem Ipsum has been.</p>
              <div class="avtar_profil">
                <div class="avatr">
                  <img src="/images/new/testi_01.png" alt="image">
                </div>
                <div class="text">
                  <h3>Willium Joe</h3>
                  <span>Careative inc.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="coustomer_slide_box">
              <div class="rating">
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
                <span><i class="icofont-star"></i></span>
              </div>
              <p>Lorem Ipsum is simply dummy text of the print ing and typese tting us orem Ipsum has been.</p>
              <div class="avtar_profil">
                <div class="avatr">
                  <img src="/images/new/testi_03.png" alt="image">
                </div>
                <div class="text">
                  <h3>Shayna john</h3>
                  <span>Careative inc.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="review_summery">
          <div class="rating">
            <span><i class="icofont-star"></i></span>
            <span><i class="icofont-star"></i></span>
            <span><i class="icofont-star"></i></span>
            <span><i class="icofont-star"></i></span>
            <span><i class="icofont-star"></i></span>
          </div>
          <p><span>5.0 / 5.0 -</span> <a href="testimonial.html">3689 Total User Reviews <i class="icofont-arrow-right"></i></a></p>
        </div>
      </div>
    </section> */}
        {/* What Our Coustomer Section End*/}
        {/* Trusted Section start */}
        <section className="row_am trusted_section">
          {/* container start */}
          {/* <div class="container">
        <div class="section_title" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="100">
          <h2>Trusted by <span>150+</span> companies</h2>
          <p>Lorem Ipsum is simply dummy text of the printing and typese tting <br> indus orem Ipsum has beenthe
            standard dummy.</p>
        </div>
        <div class="company_logos" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="100">
          <div id="company_slider" class="owl-carousel owl-theme">
            <div class="item">
              <div class="logo">
                <img src="/images/paypal.png" alt="image">
              </div>
            </div>
            <div class="item">
              <div class="logo">
                <img src="/images/spoty.png" alt="image">
              </div>
            </div>
            <div class="item">
              <div class="logo">
                <img src="/images/shopboat.png" alt="image">
              </div>
            </div>
            <div class="item">
              <div class="logo">
                <img src="/images/slack.png" alt="image">
              </div>
            </div>
            <div class="item">
              <div class="logo">
                <img src="/images/envato.png" alt="image">
              </div>
            </div>
            <div class="item">
              <div class="logo">
                <img src="/images/paypal.png" alt="image">
              </div>
            </div>
            <div class="item">
              <div class="logo">
                <img src="/images/spoty.png" alt="image">
              </div>
            </div>
            <div class="item">
              <div class="logo">
                <img src="/images/shopboat.png" alt="image">
              </div>
            </div>
          </div>
        </div>
      </div> */}
          {/* container end */}
        </section>
        {/* Trusted Section ends */}
        {/* Interface overview-Section start */}
        <section className="row_am interface_section">
          {/* <div class="section_title" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="300">
        <h2>Interface overview</h2>
        <p>
          Lorem Ipsum is simply dummy text of the printing and typese tting indus orem Ipsum has beenthe standard
          dummy text ever since.
        </p>
      </div> */}
          {/* screen slider start */}
          {/* <div class="screen_slider" data-aos="fade-in" data-aos-duration="1500" data-aos-delay="100">
        <div id="screen_slider" class="owl-carousel owl-theme">
          <div class="item">
            <div class="screen_frame_img">
              <img src="/images/new/Interface-overview-01.png" alt="image">
              <h3 class="caption">Report Page</h3>
            </div>
          </div>
          <div class="item">
            <div class="screen_frame_img">
              <img src="/images/new/Interface-overview-02.png" alt="image">
              <h3 class="caption">Dashboard</h3>
            </div>
          </div>
          <div class="item">
            <div class="screen_frame_img">
              <img src="/images/new/Interface-overview-03.png" alt="image">
              <h3 class="caption">Report Page</h3>
            </div>
          </div>
          <div class="item">
            <div class="screen_frame_img">
              <img src="/images/new/Interface-overview-02.png" alt="image">
              <h3 class="caption">Dashboard</h3>
            </div>
          </div>
          <div class="item">
            <div class="screen_frame_img">
              <img src="/images/new/Interface-overview-01.png" alt="image">
              <h3 class="caption">Report Page</h3>
            </div>
          </div>
          <div class="item">
            <div class="screen_frame_img">
              <img src="/images/new/Interface-overview-03.png" alt="image">
              <h3 class="caption">Report Page</h3>
            </div>
          </div>
        </div>
      </div> */}
          {/* screen slider end */}
        </section>
        {/* Interface overview-Section end */}
        {/* Start Your Free Trial Section Start */}
        {/* <section class="free_trial_section" data-aos="fade-in" data-aos-duration="1500">
      <div class="free_inner">

        <div class="dotes_anim_bloack">
          <div class="dots dotes_1"></div>
          <div class="dots dotes_2"></div>
          <div class="dots dotes_3"></div>
          <div class="dots dotes_4"></div>
          <div class="dots dotes_5"></div>
          <div class="dots dotes_6"></div>
          <div class="dots dotes_7"></div>
          <div class="dots dotes_8"></div>
        </div>

        <div class="text">
          <div class="section_title" data-aos="fade-up" data-aos-duration="1500">
            <h2>Start Your 14-Day Free Trial</h2>
            <p>Instant free download from apple and play store orem Ipsum is simply dummy
              text of the printing.</p>
          </div>
          <ul data-aos="fade-up" data-aos-duration="1500">
            <li>
              <p><i class="icofont-check-circled"></i>Free 14-day trial</p>
            </li>
            <li>
              <p><i class="icofont-check-circled"></i>No credit card required</p>
            </li>
            <li>
              <p><i class="icofont-check-circled"></i>Support 24/7</p>
            </li>
            <li>
              <p><i class="icofont-check-circled"></i>Cancel anytime</p>
            </li>
          </ul>
          <div class="start_and_watch" data-aos="fade-up" data-aos-duration="1500">
            <a href="contact-us.html" class="btn btn_main">GET STARTED <i class="icofont-arrow-right"></i></a>
            <a class="popup-youtube play-button" data-url="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&amp;mute=1"
              data-toggle="modal" data-target="#myModal" title="XJj2PbenIsU">
              <div class="play_btn">
                <img src="/images/play_icon-white.png" alt="image">
                <div class="waves-block">
                  <div class="waves wave-1"></div>
                  <div class="waves wave-2"></div>
                  <div class="waves wave-3"></div>
                </div>
              </div>
              <span>WATCH PROMO</span>
            </a>
          </div>
        </div>
        <div class="side_img">
          <img src="/images/new/start-free-side-img.png" alt="image">
        </div>
      </div>
    </section> */}
        {/* Start Your Free Trial Section End */}
        {/* Need support Section Start */}
        <section className="need_section">
          <div className="need_section_inner">
            <div className="container">
              <div className="need_block">
                <div className="need_text">
                  <div className="section_title">
                    <h2>Need support ? contact our team</h2>
                    <p><i className="icofont-clock-time" /> Mon - Fri: 8 am to 5 pm</p>
                  </div>
                </div>
                <div className="need_action">
                  <a href="tel:+2348060765123" className="btn"><i className="icofont-phone-circle" /> +2348060765123</a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Need support Section End */}
        {/* Footer-Section start */}
        <footer>
          <div className="top_footer" id="contact">
            {/* animated dots */}
            <div className="dotes_anim_bloack">
              <div className="dots dotes_1" />
              <div className="dots dotes_2" />
              <div className="dots dotes_3" />
              <div className="dots dotes_4" />
              <div className="dots dotes_5" />
              <div className="dots dotes_6" />
              <div className="dots dotes_7" />
              <div className="dots dotes_8" />
            </div>
            {/* container start */}
            <div className="container">
              {/* row start */}
              <div className="row">
                {/* footer link 1 */}
                <div className="col-lg-4 col-md-6 col-12">
                  <div className="abt_side">
                    <div className="logo"> <img src="/images/logo.png" alt="image" /></div>
                    <p>Unification of technological products. </p>
                  </div>
                </div>
                {/* footer link 2 */}
                <div className="col-lg-3 col-md-6 col-12">
                  <div className="links">
                    <h3>Useful Links</h3>
                    <ul>
                      <li><a href="/">Home</a></li>
                      {!AuthenticationService.getToken() && <li><Link to="/signin" > Login</Link></li> }
                      {AuthenticationService.getToken() && <li><Link to="/dashboard"> Dashboard</Link></li> }
                      {AuthenticationService.getToken() && <li><Link to="/giveaways" > Giveaways</Link></li> }

                      
                      {/* <li><a href="about-us.html">About us</a></li> */}
                    </ul>
                  </div>
                </div>
                {/* footer link 4 */}
                <div className="col-lg-5 col-md-6 col-12">
                  <div className="try_out">
                    <h3>Contact us</h3>
                    <ul>
                      <li>
                        <span className="icon">
                          <img src="/images/new/contact_01.png" alt="image" />
                        </span>
                        <div className="text">
                          <p>Reach us <br /> House 8, Garba A Idris Street, Kado, Abuja</p>
                        </div>
                      </li>
                      <li>
                        <span className="icon">
                          <img src="/images/new/contact_02.png" alt="image" />
                        </span>
                        <div className="text">
                          <p>Call us <a href="tel:+2348060765123">+2348060765123</a></p>
                        </div>
                      </li>
                      <li>
                        <span className="icon">
                          <img src="/images/new/contact_03.png" alt="image" />
                        </span>
                        <div className="text">
                          <p>Email us <a href="mailto:team@unifiedorbit.com">team@unifiedorbit.com</a></p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* row end */}
            </div>
            {/* container end */}
          </div>
          {/* last footer */}
          <div className="bottom_footer">
            {/* container start */}
            <div className="container">
              {/* row start */}
              <div className="row">
                <div className="col-md-12">
                  <p>© Copyrights 2023. All rights reserved.</p>
                </div>
                <div className="col-md-4">
                  {/* <ul class="social_media">
                <li><a href="#"><i class="icofont-facebook"></i></a></li>
                <li><a href="#"><i class="icofont-twitter"></i></a></li>
                <li><a href="#"><i class="icofont-instagram"></i></a></li>
                <li><a href="#"><i class="icofont-pinterest"></i></a></li>
              </ul> */}
                </div>
                <div className="col-md-4">
                </div>
              </div>
              {/* row end */}
            </div>
            {/* container end */}
          </div>
          {/* go top button */}
          <div className="go_top" id="Gotop">
            <span><i className="icofont-arrow-up" /></span>
          </div>
        </footer>
        {/* Footer-Section end */}
        {/* VIDEO MODAL */}
        <div className="modal fade youtube-video" id="myModal" tabIndex={-1} role="dialog" aria-labelledby="myModalLabel">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button id="close-video" type="button" className="button btn btn-default text-right" data-dismiss="modal">
                <i className="icofont-close-line-circled" />
              </button>
              <div className="modal-body">
                <div id="video-container" className="video-container">
                  <iframe id="youtubevideo" width={640} height={360} allowFullScreen />
                </div>
              </div>
              <div className="modal-footer">
              </div>
            </div>
          </div>
        </div>
      </div>
    );

}

export default withRouter(LandingPage);
